import React from 'react';
import { FaCode, FaUsers, FaGraduationCap, FaHeart } from 'react-icons/fa';

export default function Philanthropy() {
  return (
    <div className="max-w-6xl mx-auto px-4 py-12 bg-black text-gray-100">

      <h1 className="text-4xl md:text-5xl font-bold mb-8 text-transparent bg-clip-text bg-gradient-to-r from-[#4FC3F7] to-[#FF4DA6]">
        SourceCodey Impact
      </h1>

      <div className="space-y-8 text-lg">

        {/* TECH ENTREPRENEURS */}

        <section className="bg-gray-900 p-6 rounded-xl border border-gray-800">

          <h2 className="text-3xl font-bold mb-6 text-white">
            Empowering the Next Generation of Developers
          </h2>

          <p className="leading-relaxed mb-6">
            At SourceCodey, we believe technology has the power to transform lives. 
            Our mission goes beyond being a digital marketplace — we are committed 
            to empowering developers, designers, and tech innovators across the world. 
            Through our initiatives, we provide access to resources, knowledge, and 
            opportunities that enable creators to build, launch, and scale their ideas.
          </p>

          <div className="grid md:grid-cols-2 gap-6">

            <div className="bg-gray-800 p-6 rounded-lg">

              <div className="flex items-center mb-3">
                <FaCode className="text-2xl mr-3 text-[#4FC3F7]" />
                <h3 className="text-xl font-bold text-white">
                  Developer Startup Grants
                </h3>
              </div>

              <p>
                Every year, SourceCodey supports promising developers and startup founders
                by providing grants, mentorship, and marketplace exposure to help them
                launch innovative mobile apps, web apps, and AI tools.
              </p>

            </div>


            <div className="bg-gray-800 p-6 rounded-lg">

              <div className="flex items-center mb-3">
                <FaUsers className="text-2xl mr-3 text-[#FF4DA6]" />
                <h3 className="text-xl font-bold text-white">
                  Global Tech Creator Community
                </h3>
              </div>

              <p>
                We build communities where developers, designers, and tech enthusiasts
                collaborate, share knowledge, and grow together through open innovation
                and digital entrepreneurship.
              </p>

            </div>

          </div>

        </section>



        {/* EDUCATION */}

        <section className="bg-gray-900 p-6 rounded-xl border border-gray-800">

          <h2 className="text-3xl font-bold mb-6 text-white">
            Education & Digital Skills
          </h2>


          <div className="flex items-start mb-6">

            <FaGraduationCap className="text-3xl mr-4 mt-1 text-[#4FC3F7]" />

            <div>

              <h3 className="text-xl font-bold text-white mb-2">
                Programming Scholarships
              </h3>

              <p>
                SourceCodey provides scholarships and learning opportunities
                for aspiring developers to access programming courses, software
                development training, and digital entrepreneurship education.
              </p>

            </div>

          </div>


          <div className="flex items-start">

            <FaHeart className="text-3xl mr-4 mt-1 text-[#FF4DA6]" />

            <div>

              <h3 className="text-xl font-bold text-white mb-2">
                Youth Tech Labs
              </h3>

              <p>
                Our Youth Tech Labs initiative introduces students and young
                innovators to programming, artificial intelligence, and product
                development, preparing them for the digital economy.
              </p>

            </div>

          </div>

        </section>



        {/* CALL TO ACTION */}

        <section className="bg-gradient-to-r from-[#4FC3F7] to-[#FF4DA6] text-white p-8 rounded-xl">

          <div className="text-center">

            <h2 className="text-3xl font-bold mb-4">
              "Empowering Developers. Building the Future."
            </h2>

            <p className="text-xl mb-6">
              Every product sold on SourceCodey contributes to our mission of
              supporting developers, designers, and digital creators worldwide.
              Together we are building a global ecosystem where innovation thrives.
            </p>

            <div className="space-y-2">
              <p className="font-medium">
                Email: sourcecodey.com@gmail.com
              </p>

              <p className="font-medium">
                Phone: +256 708 335 802
              </p>
            </div>

          </div>

        </section>

      </div>

    </div>
  );
}